import { CSSObject } from '@chakra-ui/react';

export const TopNavContainer: CSSObject = {
  mt: '0',
  px: '0',
  pt: ['3', '1.5', '0'],
  pb: '0',
  overflowX: ['scroll', null, 'auto'],
  '::-webkit-scrollbar': {
    width: '0px',
    bg: 'transparent',
    height: '0',
  },
};
export const TopNavWrapper: CSSObject = {
  overflowX: ['scroll', null, 'visible'],
  flexDir: ['row', null, 'column'],
  minW: '160px',
  bgGradient: [
    'linear(to-b, blackAlpha.400, blackAlpha.400)',
    null,
    'linear(to-b, alpha.300, alpha.500)',
  ],
  boxShadow: [
    '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    null,
    null,
    '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset',
  ],
  borderRadius: [0, '8px'],
  px: ['10px', 0],
  mb: '2',
  '&::-webkit-scrollbar': { display: 'none' },
};
export const NavLink = (isActive: boolean): CSSObject => ({
  bg: ['unset', null, isActive ? 'blackAlpha.500' : 'transparent'],
  color: isActive ? 'beta.300' : 'white',
  textShadow: isActive
    ? 'unset'
    : ['unset', null, '0px 3px 4px rgba(0, 0, 0, 0.25)'],
  textTransform: 'uppercase',
  fontWeight: ['normal', null, 'bold'],
  fontSize: 'sm',
  lineHeight: 'normal',
  py: ['2', '3'],
  pl: isActive ? ['2', '3'] : ['2', '4'],
  pr: ['2', '4'],
  fontFamily: ['heading', null, 'accent'],
  borderBottom: [isActive && '2px solid', null, '1px dashed'],
  borderBottomColor: [
    isActive ? 'beta.300' : 'transparent',
    null,
    'rgba(0, 0, 0, 0.4)',
  ],
  borderTop: [null, null, '1px dashed'],
  borderTopColor: [null, null, 'rgba(255, 255, 255, 0.08)'],
  _first: {
    borderTop: 'none',
    borderTopRadius: ['none', null, '8px'],
    pt: ['none', null, '4'],
  },
  _last: {
    borderBottomRadius: '8px',
    borderBottom: 'none',
  },
  '&:hover, &:focus': {
    bg: isActive && 'blackAlpha.300',
  },
});

export const TopNavLabelWrapper: CSSObject = {
  mx: '2',
  color: 'white',
  fontFamily: 'accent',
};
